module.exports = __webpack_public_path__ + "img/keala.371b2c41.webp";